import { SAILS_BNT_STORAGE, SAILS_PARAM_ATOMIC_ID } from '@vfde-fe/sails-constants';
import {
    getSessionStorage,
    getURLParam,
} from '@vfde-fe/sails_core';

/**
 * Get Atomic Id
 */
export const getAtomicId = (): boolean | number => {
    return getAtomicIdFromUrl() ?? getAtomicFromStorage() ?? false;
};

const getAtomicIdFromUrl = (): number => {
    const atomicId = getURLParam(SAILS_PARAM_ATOMIC_ID);

    if (atomicId) {
        return parseInt(atomicId, 10);
    }
};

const getAtomicFromStorage = (): number => {
    const storage = getSessionStorage(SAILS_BNT_STORAGE);

    const atomicId = storage[SAILS_PARAM_ATOMIC_ID];

    if (atomicId) {
        return parseInt(atomicId, 10);
    }
};
